import { render, staticRenderFns } from "./customerList.vue?vue&type=template&id=3f79b184&scoped=true&"
import script from "./customerList.js?vue&type=script&lang=js&"
export * from "./customerList.js?vue&type=script&lang=js&"
import style0 from "./customerList.vue?vue&type=style&index=0&id=3f79b184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f79b184",
  null
  
)

export default component.exports